import { AnyAction } from 'redux';
import { UebergabeVertragsschlussverfahren } from '@ps20/bff-models';
import { CheckoutActions } from '../checkout.actions';

export interface Telefonverkauf {
  fandMitVNStatt: boolean;
  vornameGespraechspartner: string;
  nachnameGespraechspartner: string;
  uhrzeitGespraech: string;
  datumGespraech: string;
  versandArtAVB: UebergabeVertragsschlussverfahren;
  emailAVBVersand: string;
}

export const telefonverkaufReducer = function (
  sectionState: Telefonverkauf = null,
  action: AnyAction,
): Telefonverkauf {
  switch (action.type) {
    case CheckoutActions.GESPRAECH_FAND_MIT_VNSTATT_CHANGED: {
      return {
        ...sectionState,
        fandMitVNStatt: action.payload.fandMitVNStatt,
      };
    }
    case CheckoutActions.GESPRAECHSPARTNER_VORNAME_CHANGED: {
      return {
        ...sectionState,
        vornameGespraechspartner: action.payload.vornameGespraechspartner,
      };
    }
    case CheckoutActions.GESPRAECHSPARTNER_NACHNAME_CHANGED: {
      return {
        ...sectionState,
        nachnameGespraechspartner: action.payload.nachnameGespraechspartner,
      };
    }
    case CheckoutActions.GESPRAECH_DATUM_CHANGED: {
      return {
        ...sectionState,
        datumGespraech: action.payload.datumGespraech,
      };
    }
    case CheckoutActions.GESPRAECH_UHRZEIT_CHANGED: {
      return {
        ...sectionState,
        uhrzeitGespraech: action.payload.uhrzeitGespraech,
      };
    }
    case CheckoutActions.VERSANDART_AVB_CHANGED: {
      return {
        ...sectionState,
        versandArtAVB: action.payload.versandArtAVB,
      };
    }
    case CheckoutActions.EMAIL_AVB_VERSAND_CHANGED: {
      return {
        ...sectionState,
        emailAVBVersand: action.payload.emailAVBVersand,
      };
    }
    default:
      return sectionState;
  }
};
